import type { CurrentRead } from '@signalvote/data';
import type { DashboardRosterDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { financeReadKeys } from '../../lib/queryKeys';
import { campaignHeaders, defineQuery } from '../../lib/data';

export type { DashboardRosterDto };

const useDashboardRosterRead = defineQuery({
  key: financeReadKeys.dashboardRoster,
  reads: 'GET /api/finance/dashboard/roster',
  fetch: (_params: undefined, { signal, campaignId }) =>
    apiJson<DashboardRosterDto>('/api/finance/dashboard/roster', {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch dashboard roster',
    }),
  staleTime: 30_000,
});

/**
 * The dashboard accounts & sources roster (ADR-017): two provenance-only
 * sections — Bank accounts and Sources you import from. No money-at-rest figure
 * (no balance, no per-source dollar total, no totals row).
 */
export function useDashboardRoster(): CurrentRead<DashboardRosterDto> {
  return useDashboardRosterRead(undefined);
}
